import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["employeeDetail"];

  connect() {
    this.toggleEmploymentDetails();
  }

  toggleEmploymentDetails() {
    const employmentStatus = this.element.querySelector(
      '[name="[employment_detail][employment_status]"]'
    ).value;
    if (employmentStatus == "2") {
      this.employeeDetailTarget.classList.add("hidden");
    } else {
      this.employeeDetailTarget.classList.remove("hidden");
    }
  }
}
